







import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/components/common/icon.vue';
import { ConstantsModuleMapper } from '@/store/modules/constants';

@Component({
  props: {
    isOpened: Boolean,
  },
  components: {
    Icon,
  },
  computed: {
    ...ConstantsModuleMapper.mapState(['list']),
  },
})
export default class SearchBarButtonComponent extends Vue {
  toggleSearch() {
    this.$emit('toggle', !this.$props.isOpened);
  }
}
